import styled from "styled-components";

export default styled.p`
  color: #f0f0f0;
  font-family: Helvetica, segui;
  font-size: 76px;
  line-height: 120px;
  margin: 20px;
  padding: 0;
  ::selection {
    background: #1abc9c;
  }
`;



// WEBPACK FOOTER //
// ./src/components/text.js